import { usePatchStudentAssignment } from '../data/usePatchStudentAssignment';

export type ChangeStudentPayload = {
  studentAccountExternalId: string;
};

export function useChangeStudent(applicationId: string) {
  const { patchStudentAssignment, isPatchingStudentAssignment } = usePatchStudentAssignment(applicationId);

  async function changeStudent(payload: ChangeStudentPayload) {
    return await patchStudentAssignment(payload);
  }

  return {
    changeStudent,
    isPatchingStudentAssignment,
  };
}
